const ANIMATION_TEXT_CONTENT = [
  "Fully Encrypted Internet",
  "Ensure Privacy & Security",
  "High Speed & Open access",
  "No Regional Limitations",
];

export { ANIMATION_TEXT_CONTENT };
